document.addEventListener('DOMContentLoaded', function() {
  const deferredVideos = document.querySelectorAll('deferred-media video');
  
  deferredVideos.forEach(video => {
    video.muted = true;          // Assicurati che sia silenziato
    video.play().catch(() => {}); // Prova ad avviare il video
  });
});
